import { render, staticRenderFns } from "./refundDetailDialogGoods.vue?vue&type=template&id=5d4b9f6a&scoped=true&"
import script from "./refundDetailDialogGoods.vue?vue&type=script&lang=js&"
export * from "./refundDetailDialogGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4b9f6a",
  null
  
)

export default component.exports